import { useState } from 'react';
import { Check, Clipboard, WrapText } from 'lucide-react';
import clsx from 'clsx';

export function JsonResultView({ value }: { value: unknown }) {
  const [copied, setCopied] = useState(false);
  const [wrap, setWrap] = useState(true);
  const text = JSON.stringify(value, null, 2);
  return (
    <div className="relative">
      <pre
        className={clsx(
          'max-h-[60vh] overflow-auto rounded-md border border-line bg-bg-soft p-3 font-mono text-xs leading-relaxed text-ink',
          wrap ? 'whitespace-pre-wrap break-all' : 'whitespace-pre'
        )}
      >
        {text}
      </pre>
      <div className="absolute right-2 top-2 flex items-center gap-1">
        <button
          className={clsx('btn-ghost', wrap && 'text-accent')}
          onClick={() => setWrap((v) => !v)}
          title={wrap ? '关闭自动换行' : '启用自动换行'}
        >
          <WrapText className="h-3.5 w-3.5" />
          <span className="text-xs">{wrap ? '换行' : '不换行'}</span>
        </button>
        <button
          className="btn-ghost"
          onClick={() => {
            navigator.clipboard.writeText(text).then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            });
          }}
        >
          {copied ? <Check className="h-3.5 w-3.5" /> : <Clipboard className="h-3.5 w-3.5" />}
          <span className="text-xs">{copied ? '已复制' : '复制'}</span>
        </button>
      </div>
    </div>
  );
}
